import { SettingsModal, SETTINGS_TABS } from "./index";
import { SupportPanel } from "./SupportPanel";

// Route element for /settings/support.
export const SupportSettings = () => (
  <SettingsModal active={SETTINGS_TABS.SUPPORT}>
    <SupportPanel />
  </SettingsModal>
);
